module.exports = __webpack_public_path__ + "static/media/th-box.4da00125.svg";